import * as Sentry from '@sentry/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: '', // Replace with fuel-app Sentry DSN once created
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.25,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .catch(err => console.error(err));
